/**
 * Daily Challenge API
 */

export interface DailyQuestion {
  id: string;
  text: string;
  options: string[];
  category?: string;
  categoryEmoji?: string;
  quizTopic?: string;
}

export interface DailyInfo {
  date: string;
  questions: DailyQuestion[];
  alreadyPlayed: boolean;
  previousResult?: {
    score: number;
    correctAnswers: number;
    percentile: number;
    grid: string;
  };
}

export interface DailySubmitResult {
  success: boolean;
  score: number;
  correctAnswers: number;
  totalQuestions: number;
  percentile: number;
  position: number;
  totalPlayers: number;
  grid: string;
  xpAwarded: number;
  dailyStreak: number;
}

export interface DailyAnswer {
  questionId: string;
  answerIndex: number;
  timeSpent: number;
}

const API_BASE = '/api/swipe';

// Auth headers
function getAuthHeaders(): Record<string, string> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  const tg = (window as any).Telegram?.WebApp;
  if (tg?.initDataUnsafe?.user?.id) {
    headers['X-Telegram-User-Id'] = String(tg.initDataUnsafe.user.id);
  } else {
    const guestId = localStorage.getItem('beshek_guest_id');
    if (guestId) {
      headers['X-Guest-Id'] = guestId;
    }
  }
  return headers;
}

export async function fetchDailyChallenge(): Promise<DailyInfo> {
  const response = await fetch(API_BASE + '/daily', {
    headers: getAuthHeaders(),
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch daily challenge');
  }
  
  return response.json();
}

export async function submitDailyChallenge(answers: DailyAnswer[]): Promise<DailySubmitResult> {
  const response = await fetch(API_BASE + '/daily/submit', {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({ answers }),
  });
  
  if (!response.ok) {
    if (response.status === 409) {
      throw new Error('Already played today');
    }
    throw new Error('Failed to submit daily challenge');
  }
  
  return response.json();
}
